import { useNavMenus } from '@/utils/hooks/useMenus';
import Copyright from './Copyright';
import FooterLinkSection from './FooterLinkSection';
import FooterTerms from './FooterTerms';
import 'twin.macro';

function Footer() {
  const { menuData } = useNavMenus();

  const footerMenuData = menuData.footer;
  const termsMenuData = menuData.terms && menuData.terms.menuItems;
  const copyrightMenuData = menuData.copyright && menuData.copyright.menuItems;
  return (
    <>
      <div tw=" mx-auto flex w-full flex-col  items-center  bg-gray-100  sm:py-3">
        <div tw=" mx-4 flex w-full flex-col items-center  justify-center overflow-hidden align-middle xl:max-w-7xl">
          {footerMenuData && (
            <FooterLinkSection footerItems={footerMenuData.menuItems} />
          )}
          <div>
            {termsMenuData && <FooterTerms items={termsMenuData} />}
          </div>
        </div>
      </div>
      {copyrightMenuData && <Copyright copyrightItems={copyrightMenuData} />}
    </>
  );
}

export default Footer;
